import { DateTime } from 'luxon';

export class FlatItem
{
    public channel: string;
    public channelId: number;
    public unit: string;
    public value: string;
    public rawValue?: number;

    constructor (public dateTime: DateTime)
    {
    }
}
